import { useCurrentUser } from '../user';

import { useEmployerStaff } from './useEmployerStaff';

export const useCurrentEmployerStaff = () => {
  const { user } = useCurrentUser();
  const { employerStaff, loading } = useEmployerStaff(user?.employerStaff?.id);

  const employerStaffId = employerStaff?.id;
  const employerId = employerStaff?.employer.id;

  return {
    employerStaffId,
    employerStaff,
    employerId,
    loading,
  };
};
